import React from 'react';
import { Link } from 'react-router-dom';

import { workQueueRoute } from 'App/common/routeLookup';
import { cdnURL } from 'App/components/config/config';

function Logo() {
    return (
        <div className="logo">
            <Link to={workQueueRoute}>
                <img
                    id="therigy-logo"
                    src={`${cdnURL}/images/stm/therigySTM-Logo-LightMode.png`}
                    alt="Therigy - The Trusted Source for Specialty Solutions"
                />
            </Link>
        </div>
    );
}

export default Logo;
